import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Title, Text, Tabs, Stack, TextInput, Textarea, NumberInput, Button, Alert, FileInput, Group, Radio } from '@mantine/core';
import { IconBrandYoutube, IconUpload, IconLock, IconInfoCircle, IconVideo } from '@tabler/icons-react';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.ailinkb.shop';

export default function PublishSkillCard({ user }) {
  const { t } = useTranslation();
  const [videoUrl, setVideoUrl] = useState('');
  const [videoFile, setVideoFile] = useState(null);
  const [packageFile, setPackageFile] = useState(null);
  const [tags, setTags] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState(9.99);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const hasPro = user?.subscriptionPlan?.startsWith('PRO') || user?.role === 'ADMIN' || user?.email === 'office@ailinkb.shop';
  

  const handlePublishFree = () => {
    if (!title || !description || !packageFile || !videoFile) {
      alert(t("fill_all_fields", "Wypełnij wszystkie pola!"));
      return;
    }
    
    setLoading(true);
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('videoUrl', ""); // we send videoFile instead
    formData.append('tags', tags);
    formData.append('price', price);
    formData.append('ownerEmail', user?.email || 'guest@example.com');
    formData.append('packageFile', packageFile);
    formData.append('videoFile', videoFile);

    fetch(`${API_BASE_URL}/api/skills/submit-with-file`, {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(data => {
      setLoading(false);
      if (data.success) {
        setMessage(data.message);
        setVideoUrl(''); setPackageFile(null); setTags(''); setTitle(''); setDescription(''); setPrice(9.99);
      } else {
        alert(data.error || t("generic_error", "Wystąpił błąd"));
      }
    })
    .catch(err => {
      setLoading(false);
      alert(t("connection_error", "Błąd połączenia: ") + err);
    });
  };

  const handleSubmit = () => {
    if (!title || !description || !videoUrl || !packageFile) {
      alert(t("fill_all_fields", "Wypełnij wszystkie pola!"));
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('videoUrl', videoUrl);
    formData.append('tags', tags);
    formData.append('price', price);
    formData.append('ownerEmail', user?.email || 'guest@example.com');
    formData.append('packageFile', packageFile);

    fetch(`${API_BASE_URL}/api/skills/submit-with-file`, {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(data => {
      setLoading(false);
      if (data.success) {
        setMessage(data.message);
        setVideoUrl(''); setPackageFile(null); setTags(''); setTitle(''); setDescription(''); setPrice(9.99);
      } else {
        alert(data.error || t("generic_error", "Wystąpił błąd"));
      }
    })
    .catch(err => {
      setLoading(false);
      alert(t("connection_error", "Błąd połączenia: ") + err);
    });
  };

  return (
    <Card shadow="sm" radius="md" withBorder p="xl" maw={600} mx="auto">
      <Title order={3} mb="md">{t('publish_sell_title', 'Opublikuj i Sprzedawaj Swój Skill')}</Title>
      <Text c="dimmed" mb="md">{t('publish_sell_desc', 'Wybierz sposób wgrania wideo pokazującego twój produkt lub bota AI.')}</Text>
      
      <Alert color="green" variant="light" mb="md" icon={<IconInfoCircle />}>
          <Text fw={600}>{t('free_skill_promo', '🎁 Publikacja Skilli i Promptów na naszej platformie jest całkowicie DARMOWA! Nie ponosisz ryzyka – pobieramy jedynie 30% prowizji dopiero po udanej sprzedaży.')}</Text>
        </Alert>
      
      {message && <Alert color="green" mb="md">{message}</Alert>}

      <Stack gap="md">
          <FileInput label={t("select_video_file", "Wybierz plik wideo (MP4)")} placeholder={t("click_to_select", "Kliknij by wybrać...")} accept="video/mp4" leftSection={<IconVideo size={16} />} value={videoFile} onChange={setVideoFile} clearable />
          <TextInput label={t("skill_title", "Tytuł / Nazwa Skilla")} value={title} onChange={e => setTitle(e.target.value)} />
          <FileInput label={t("skill_package_file", "Paczka Skilla (.zip, .py, .json)")} placeholder={t("click_to_select", "Kliknij by wybrać...")} value={packageFile} onChange={setPackageFile} clearable />
          <TextInput label={t("skill_tags", "Tagi / Technologie (np. Python, JS, Prompty)")} placeholder="Python, GPT-4, Automatyzacja" value={tags} onChange={e => setTags(e.target.value)} />
          <Textarea label={t("skill_description", "Opis i Instrukcje")} value={description} onChange={e => setDescription(e.target.value)} />
          <NumberInput label={t("skill_price", "Cena (EUR)")} min={0} value={price} onChange={v => setPrice(v)} />
          <Button size="md" color="blue" fullWidth onClick={handlePublishFree} loading={loading}>{t('proceed_to_publish_free', 'Opublikuj za darmo (Prowizja 30% po sprzedaży)')}</Button>
        </Stack>
    </Card>
  );
}
